"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parsePhoneNumber = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _arrays = require("../arrays");
/* eslint-disable import/prefer-default-export */

var parsePhoneNumber = exports.parsePhoneNumber = function parsePhoneNumber(phoneNumber, countries, defaultCountry) {
  var ignoreSuggestions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (typeof phoneNumber !== 'string') {
    return undefined;
  }
  if (phoneNumber.startsWith('+')) {
    var matchingCountry = countries.filter(function (country) {
      return phoneNumber.startsWith(country.callingCode);
    }).sort(function (a, b) {
      return (
        // prefer longer callingCode match
        (0, _arrays.sortByNumericValue)(function (e) {
          return e.callingCode.length;
        })(b, a) ||
        // if defaultCountry is given, prefer that callingCode
        (0, _arrays.sortByPreferringTruthy)(function (e) {
          return e.code === (defaultCountry == null ? void 0 : defaultCountry.code);
        })(a, b) ||
        // prefer higher priority (i.e. lower value)
        (0, _arrays.sortByNumericValue)(function (e) {
          var _e$priority;
          return (_e$priority = e.priority) !== null && _e$priority !== void 0 ? _e$priority : 0;
        })(a, b)
      );
    })[0];
    if (!matchingCountry) {
      return {
        phoneNumber
      };
    }
    if (!ignoreSuggestions && matchingCountry !== defaultCountry) {
      var suggestedCountries = countries.filter(function (country) {
        return country.callingCode.startsWith(phoneNumber) && country.callingCode.length > phoneNumber.length;
      });
      if (suggestedCountries.length > 0) {
        // current input could end up matching another callingCode, do not resolve country
        return {
          phoneNumber
        };
      }
    }
    return (0, _extends2.default)({}, matchingCountry, {
      phoneNumber: phoneNumber.substring(matchingCountry.callingCode.length)
    });
  }
  return (0, _extends2.default)({}, defaultCountry, {
    phoneNumber
  });
};